module.exports = __webpack_public_path__ + "img/img6.3754ae31.png";